import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import logoLight from '../assets/images/logo-light.png'

const PWReset = () => {
    const [dataBlock] = useState({
        title:"Forgot Your Password?",
        subTitle:"Change your password in three easy steps. This helps to keep your new password secure."
    })
  return (
    <>
       <section className="items-center flex bg-[url('../images/login_bg.jpg')] bg-cover bg-center relative py-20 min-h-screen">
        <div className="bg-[#0d0f14]/25 absolute inset-0 backdrop-blur-md"></div>
        <div className="container relative">
            <div className="grid grid-cols-1">
                <div className="max-w-[450px] mx-auto">
                    <Link to="/landing/">
                        <img src={logoLight} alt="logo" className="mx-auto h-10"/>
                    </Link>
                </div>
            </div>
            <div className="grid grid-cols-1 mt-16">
                <div className="max-w-[450px] mx-auto py-10 px-8 rounded-xl bg-white w-full">
                    <h4 className="font-bold text-2xl mb-2 text-center capitalize">{dataBlock.title}</h4>
                    <p className="text-muted text-center">{dataBlock.subTitle}</p>
                    <form className="mt-6 space-y-4">
                        <div>
                            <label className="font-bold">Email Address</label>
                            <input type="text" className="form-input mt-2 rounded !bg-white border border-[#ced4da] text-base focus:border-custom" placeholder="Email Id"/>
                        </div>
                        <div>
                            <button type="submit" className="btn-custom w-full">Get New Password</button>
                        </div>
                    </form>
                </div>
                <div className="text-center mt-6">
                    <p><small className="text-white mr-2">Already have an account?</small> <Link to="/account/" className="text-white font-bold">Sign in</Link></p>
                </div>
            </div>
        </div>
    </section>
    </>
  )
}

export default PWReset
